export const applyTheme = () => {
  let pref = null;
  try { pref = localStorage.getItem("gf_theme"); } catch {}
  const light = pref === "light";
  document.documentElement.classList.toggle("light", light);
  return light;
};

export const setTheme = (mode) => {
  try { localStorage.setItem("gf_theme", mode); } catch {}
  return applyTheme();
};
